declare global {
  interface Navigator {
    bluetooth: any;
  }
}

import { Component } from '@angular/core';

@Component({
  selector: 'app-scale',
  templateUrl: './scale.component.html',
  styleUrls: ['./scale.component.css']
})
export class ScaleComponent {
  async connectToBluetoothDevice() {
    try {
      const device = await navigator.bluetooth.requestDevice({
        filters: [{ name: 'MIBFS' }]
      });

      console.log('Dispositivo encontrado:', device.name);
      console.log('Estado del dispositivo:', device.gatt?.connected ? 'Conectado' : 'Desconectado');
    } catch (error) {
      console.error('Error al conectar con el dispositivo Bluetooth:', error);
    }
  }
} 